var _style, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuickAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 48,
    height: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2,33.6l-8.7-9.3c-0.1-0.1-0.1-0.4,0-0.5l8.7-9.3c1-1.1,1.2-2.7,0.7-4c-0.5-1.3-1.8-2.1-3.2-2.1H15.2 c-1.4,0-2.7,0.8-3.2,2.1c-0.6,1.3-0.4,2.9,0.7,4l8.8,9.3c0.1,0.1,0.1,0.4,0,0.5l-8.7,9.3c-1,1.1-1.2,2.7-0.7,4 c0.5,1.3,1.8,2.1,3.2,2.1h17.4c1.4,0,2.7-0.8,3.2-2.1C36.4,36.3,36.2,34.7,35.2,33.6z M14.2,13c-0.5-0.5-0.4-1.2-0.3-1.7 c0.1-0.2,0.4-0.9,1.2-0.9h17.4c0.8,0,1.2,0.6,1.2,0.9c0.2,0.4,0.3,1.2-0.3,1.7l-8.7,9.2c-0.3,0.3-0.6,0.4-1,0.4 c-0.4,0-0.7-0.2-1-0.4L14.2,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuickAlarm);
export default __webpack_public_path__ + "static/media/ic_quick_alarm.fe83856109665c2036072e507062de12.svg";
export { ForwardRef as ReactComponent };